import React from 'react'
import { Icon } from '@centivo/react-components'
import { useSliceTemplate } from 'src/context/global'
import { useResultsState } from 'src/context/results'
import styled from 'styled-components'

const ErrorMessageContainer = styled.div`
  max-width: 1130px;
  width: 100%;
  height: auto;
  display: flex;

  margin-top: 8px;
  padding: 10px 12px;
  gap: 13px;

  background-color: #fceded;
  border: solid 1px #d62020;
  border-radius: 4px;

  h1 {
    font-size: 1rem;
    font-weight: 700;
    line-height: 22px;
  }

  p {
    margin-top: 2px;

    font-size: 0.75rem;
    font-weight: 500;
    line-height: 16px;
  }
`

const ErrorIcon = styled(Icon)`
  color: #d62020;
  min-width: 22px;
  min-height: 22px;
  margin: 1px 0 0 1px;

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          minHeight: '24px',
          minWidth: '24px',
        }
      default:
        return {
          minHeight: '22px',
          minWidth: '22px',
        }
    }
  }}
`

export const NoResultsErrorMessage: React.FC = () => {
  const [state] = useResultsState()

  const distanceInMiles = state.filter?.distance ?? '20'

  const isSliceTemplate = useSliceTemplate()

  return (
    <ErrorMessageContainer>
      <ErrorIcon
        icon={
          isSliceTemplate ? 'slice-fill-error-diamond' : 'fill-error-circle'
        }
        aria-hidden
      />
      <div>
        <h1>No results found within {distanceInMiles} miles</h1>
        <p>
          Please try changing your search criteria, and keep in mind our search
          field is sensitive to spelling and punctuation (like hyphens and
          apostrophes). If you need assistance, check your enrollment materials
          for how to contact Centivo Member Care.
        </p>
      </div>
    </ErrorMessageContainer>
  )
}
